<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="3">未开始</a-select-option>
                <a-select-option value="4">已结束</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />上架</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.title}}</div>
        <div>
          <img style="width: 68px ; height: 68px; float: left" :src="record.pic_url" />
          <div style="color: #999;margin-left: 10px; float: left">
            <span style="color: #f5212d">¥ {{record.price_range[0]|price}} - {{record.price_range[1]|price}}</span>
            <br/>
            库存: {{record.stock}}
            <br/>
            <a-badge status="success" v-if="record.status==1" text="进行中" />
            <a-badge status="processing" v-else-if="record.status==3" text="未开始" />
            <a-badge status="default" v-else-if="record.status==4" text="已结束" />
            <a-badge status="default" v-else text="已下架" />
          </div>
        </div>
      </span>
      <span slot="timeRange" slot-scope="text,record">
        <template >
        <div>
          开始:{{record.time_start|timeFormat}}<br/>
          结束:{{record.time_end|timeFormat}}
        </div>
          </template>
      </span>
      <span slot="orderCount" slot-scope="text,record">
        <template >
        <div>
          {{record.tuan_count}}/{{record.order_count}}
        </div>
        </template>
      </span>
      <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />

          <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
          <a @click="handleUserManage(record)">参与记录</a>
            </a-menu-item>
            <a-menu-item>
            <a href="javascript:;" @click="onShare(record)">小程序推广</a>
            </a-menu-item>
             <a-menu-item>
                <a href="javascript:;" @click="onH5Share(record)">H5版推广</a>
              </a-menu-item>
            <a-menu-item>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        </template>
      </span>
    </s-table>


    <a-modal
            title="操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-form-item
                  label="所属商品"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-select
                    showSearch
                    v-model="formData.goods_id"
                    optionFilterProp="title"
                    :disabled="formData.id>0"
                    @change="goodsChange"
                    placeholder="选择商品"
            >
              <a-select-option :key="option.id" v-for="option in goodsOptions" :title="option.title" :disabled="option.disabled" :value="option.id">{{option.title}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
          >
            <a-input v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入标题' }]}
        ]"
                     placeholder="请输入标题"/>
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="活动时间"
                  hasFeedback
          >
            <a-range-picker
                    v-model="formData.time_range_moment"
                    :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
                    format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="成团人数"
                  hasFeedback
          >
            <a-input tyoe="number" v-decorator="[
          'complete_count',
          {rules: [{ required: true, message: '请输入人数' }]}
        ]"
                     placeholder="请输入人数"/>
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="成团时限"
                  hasFeedback
                  extra="团长支付成功后,限多少小时内邀请好友参团"
          >
            <a-input tyoe="number" v-decorator="[
          'time_limit',
          {rules: [{ required: true, message: '请输入小时数' }]}
        ]"
                     placeholder="请输入小时数"/>
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="自动成团"
                  hasFeedback
          >
            <a-switch checkedChildren="是" v-model="formData.auto_complete" unCheckedChildren="否" defaultChecked/>
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="状态"
                  hasFeedback
          >
            <a-switch checkedChildren="上架" v-model="formData.status" unCheckedChildren="下架" />
          </a-form-item>
        </a-form>
        <a-table :columns="skuColumns" v-show="skuTable.sku_list.length" :dataSource="skuTable.sku_list" :pagination="false" rowKey="key"  bordered>
          <template slot="customPrice">
            <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllPrice">
              <span slot="icon" />
              <template slot="title">
                <PriceInput :formData="setAll"
                            field="setAllPriceValue"
                            placeholder="批量设置拼团价"/>
              </template>
              拼团价 <a-icon type="form" />
            </a-popconfirm>
          </template>
          <template slot="id" slot-scope="text,record,index">
            <a-input v-model="record.id" placeholder="id"/>
          </template>
          <template slot="price" slot-scope="text,record,index">
            <PriceInput :formData="record"
                        field="pin_price"
                        placeholder="价格"/>
          </template>
        </a-table>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
            title="订单记录"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="userColumns" :dataSource="tuanUserList" :pagination="userPagination"
                   @change="handleUserTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索用户名/手机号"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.user_name}}
            </span>
            <span slot="member_count" slot-scope="text,record">
              {{record.member_count}}/{{record.total_member_count}}
            </span>
            <span slot="status" slot-scope="text,record">
            <a-badge status="processing" v-if="record.status==1" text="进行中" />
            <a-badge status="success" v-else-if="record.status==2" text="完成" />
            <a-badge status="error" v-else-if="record.status==3" text="过期失败" />
            <a-badge status="default" v-else-if="record.status==4" text="未支付" />
            </span>
            <span slot="time_start" slot-scope="text,record">
            开始:{{record.time_start|timeFormat}}<br/>
            结束:{{record.time_end|timeFormat}}
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
            title="小程序推广"
            v-model="shareVisible"
            @ok="shareVisible=false"
    >
      <p style="text-align: center"><img :src="share.wxmini_pic_url" /></p>
    </a-modal>
    <a-modal title="H5推广" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>{{share.site_url}} </p><a  
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">点此复制</a>
    </a-modal>
  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PriceInput from '@/components/PriceInput/'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getGoodsOptions,getTuanList,getGoodsSkuDetail,addTuan,editTuan,getTuanDetail,setTuanRank,deleteTuan,setTuanAllStatus,getTuanUserList } from '@/api/tuan'
  export default {
    name: 'TuanList',
    components: {
      AInput,
      ATextarea,
      STable,
      EditableCell,
      PriceInput
    },
    data () {
      return {
        visible: false,
        userVisible:false,
        shareVisible: false,
        h5ShareVisible:false,
        share:{
          wxmini_pic_url:'',
          site_url:''
        },
        areaVisible: false,
        saveLoading:false,
        formData:{
          id:0,
          title:'',
          time_range_moment:[],
          time_range:[],
          complete_count:3,
          time_limit:24,
          auto_complete:true,
          status:true,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        cateOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            width:'250px',
            title: '活动时间',
            dataIndex: 'time_start',
            scopedSlots: { customRender: 'timeRange' },
          },
          {
            title: '开团/订单',
            width:'100px',
            dataIndex: 'order_count',
            scopedSlots: { customRender: 'orderCount' },
          },
          {
            title: '排序',
            width:'150px',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          }
        ],

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam.cate_id = 0;
          if(this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
            this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
          }
          this.queryParam = Object.assign(this.queryParam,parameter);
          return getTuanList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },
        selectedRowKeys: [],
        selectedRows: [],
        goodsOptions:[],
        sku_fields_list:[],
        setAll:{
          setAllPriceValue:''
         },
        skuTable:{
          sku_fields_sets:[],
          sku_list:[],
        },

      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '团长',
          dataIndex: 'user_name',
          width:'150px',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'name',
          }
        },
        {
          title: '参与/成团人数',
          width:'100px',
          dataIndex: 'member_count',
          scopedSlots: {
            customRender: 'member_count',
          },
        },
        {
          title: '状态',
          width:'100px',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          filters: [
            {
              text: '进行中',
              value: '1'
            },
            {
              text: '完成',
              value: '2'
            },
            {
              text: '过期失败',
              value: '3'
            },
            {
              text: '未支付',
              value: '4'
            }],
          filterMultiple:false,
        },
        {
          title: '时间',
          width:'150px',
          dataIndex: 'time_start',
          scopedSlots: {
            customRender: 'time_start',
          },
        },
    ],
      userPagination:{
        pageSize: 30,
        page: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      userQuery:{
        tuan_id:0,
                status:0,
                page:1,
                keywords:undefined
      },
      tuanUserList:[]
      }
    },
    computed:{
      skuColumns(){
        let self = this;
        let skuColums = [];
        self.sku_fields_list.map((item,index) =>{
          if(item.attrs.length ==0){
            return;
          }
          skuColums.push({
            title: ''+item.title,
            width: 100,
            dataIndex: 'sku['+index+'].attr_title',
            customRender: (value, row, index2) => {
              const obj = {
                children: value,
                attrs: {},
              };
              let rowSpan = self.skuTable.sku_fields_sets[index][0].height;
              if(index2 % rowSpan ==0){
                obj.attrs.rowSpan = rowSpan;
              }else{
                obj.attrs.rowSpan = 0;
              }
              return obj;
            }
          });
        });
        let constColums =  [
          {
            width: 100,
            dataIndex: 'price',
            title:'原价',
            customRender: (text) =>  {
              return (text/100).toFixed(2)
            }
          },
          {
            width: 100,
            dataIndex: 'pin_price',
            slots: { title: 'customPrice' },
            scopedSlots: { customRender: 'price' }
          },
          {
            width: 100,
            title:'库存',
            dataIndex: 'stock',
          },
          {
            width: 100,
            title:'成本',
            dataIndex: 'cost_price',
            customRender: (text) =>  {
              return (text/100).toFixed(2)
            }
          },
        ];
        return skuColums.concat(constColums);
      }
    },
    created(){
    },
    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      // 增
      handleAdd() {
        console.log('moment.locale()')
        console.log(moment.locale());
        let that = this;
        that.getGoodsOptions();
        this.visible = true;
        this.form.resetFields();
        this.formData = {
          id:0,
          title:'',
          time_range_moment:[],
          time_range:[],
          complete_count:3,
          time_limit:24,
          auto_complete:true,
          status:true,
        };
        setTimeout( () =>{
          that.form.setFieldsValue({ ...this.formData });
        });
      },
      // 改
      handleEdit(record) {
        let self = this
        getTuanDetail({ id: record.id }).then(res => {
          self.form.setFieldsValue({ ...res.data })
          self.formData.id = record.id;
          self.formData.title = res.data.title;
          self.formData.goods_id = res.data.goods_id;

          self.formData.time_range_moment = [moment(res.data.time_start*1000),moment(res.data.time_end*1000)];
          self.formData.auto_complete = res.data.auto_complete==1?true:false;
          self.formData.status = res.data.status==2?false:true;

          self.formData.sku = res.data.sku;
          self.sku_fields_list = res.data.sku_fields_list;
          self.refreshSkuList();
        })
        // console.log(this.mdl)
        this.visible = true
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(!self.formData.goods_id){
          self.$message.error('请选择商品');
          return ;
        }
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id) {
              editTuan({
                id:self.formData.id,
                title:values.title,
                time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                complete_count:values.complete_count,
                time_limit:values.time_limit,
                auto_complete:self.formData.auto_complete? 1: 2,
                status:self.formData.status? 1: 2,
                sku_list:self.skuTable.sku_list,
                user_buy_limit:0,
              }).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(true)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addTuan({
                title:values.title,
                goods_id:self.formData.goods_id,
                time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                complete_count:values.complete_count,
                time_limit:values.time_limit,
                auto_complete:self.formData.auto_complete? 1: 2,
                status:self.formData.status? 1: 2,
                sku_list:self.skuTable.sku_list,
                user_buy_limit:0,
              }).then(res => {
                self.$message.success('新增成功')
                self.$refs.table.refresh(true)
                self.visible = false
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },
      goodsChange(goods_id){
        console.log(goods_id)
        if(!goods_id){
          return [];
        }
        let that = this
        getGoodsSkuDetail({ goods_id: goods_id }).then(res => {
          that.formData.title=res.data.goods_title,
          that.form.setFieldsValue({ title:res.data.goods_title})
          that.formData.sku = res.data.sku;
          that.sku_fields_list = res.data.sku_fields_list;
          that.refreshSkuList();
        }).catch(err =>{
          that.$message.error(err.data.msg)
        })
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(true)
    },
      setAllStatus(status){
        let self = this;
        setTuanAllStatus({
          ids:self.selectedRowKeys,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(true)
                })
      },
      setStatus(goods_id,status){
        setGoodsStatus({
          id:goods_id,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(true)
                })
      },

      onShare(record){
        let that = this;
        that.shareVisible = true;
        that.share.wxmini_pic_url = record.wxmini_pic_url;
      },
      onH5Share(record) {
      console.log(record)
      let that = this
      that.h5ShareVisible = true
      that.share.site_url=record.h5_url
      that.share.wxmini_pic_url = record.h5_pic_url
    },
    onCopy(e){
      this.$message.success('复制成功')
      },
      onError(e){
        this.$message.error('复制失败')
      },
     // 删
      deleteHandle(record) {
        let self = this
        deleteTuan({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
      }).catch(err =>{
          self.$message.error(err.data.msg)
        })
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setTuanRank({
        id: key,
        rank:value
      }).then(res => {
        self.$refs.table.refresh(true)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    getGoodsOptions(){
        let self = this;
        getGoodsOptions( ).then(res => {
          self.goodsOptions = res.data;
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      refreshSkuList(){
        let self = this;
        var sets = [];
        var skulist = [];
        var count = [];
        if(this.sku_fields_list.length==0 || this.sku_fields_list[0].attrs.length==0){
          return {
            'sku_fields_sets' : sets,
            'sku_list' : skulist,
          }
        }
        for(var i = this.sku_fields_list.length-1 ; i >=0 ; i-- ){
          var key = this.sku_fields_list.length-1-i;
          var rkey = i;
          var list = [];
          var len = this.sku_fields_list[i].attrs.length;
          if(i-1>=0){
            count[i-1] = len * ( count[i] ? count[i] : 1);
          }

          sets[key] = [];
          if (key == 0) {
            for(var l = 0 ; l<this.sku_fields_list[key].attrs.length ; l++ ){
              sets[key].push({
                'id' : this.sku_fields_list[key].attrs[l].id,
                'title' : this.sku_fields_list[key].attrs[l].title,
                'sku' : [{
                  'field_id': this.sku_fields_list[key].id,
                  'attr_id': this.sku_fields_list[key].attrs[l].id,
                  'attr_title': this.sku_fields_list[key].attrs[l].title,
                }]
              })
            }
          } else {
            var ccount =  sets[key-1].length;
//                        console.log('ccount');
//                        console.log(ccount);
            for(var n = 0; n < ccount ; n++) {
              for(var j= 0; j <  this.sku_fields_list[key].attrs.length ; j++){
                var sku = sets[key-1][n]['sku'];
                sets[key].push(
                        {
                          'id' : this.sku_fields_list[key].attrs[j].id,
                          'title' : this.sku_fields_list[key].attrs[j].title,
                          'sku' : sku.concat({
                            'field_id': this.sku_fields_list[key].id,
                            'attr_id': this.sku_fields_list[key].attrs[j].id,
                            'attr_title': this.sku_fields_list[key].attrs[j].title,
                          })
                        }
                )
              }
//                            sets[key] = sets[key].concat(this.sku_fields_list[key].attrs);
            }
//                        console.log('set');
//                        console.log(sets[key]);
          }
        }

        for( var k = 0 ; k < sets.length ; k++){
          for(var index = 0 ; index < sets[k].length ;  index++){
            sets[k][index].height = count[k] ? count[k] : 1;
          }
        }
        if(sets[sets.length-1].length==0){
          sets.splice(sets.length-1,1);
        }
        for(var m=0; m< sets[sets.length-1].length ; m++){
          var row = {
            'key' : 'm'+m,
            'id' : 0,
            'code' : '',
            'price' : 0,
            'pin_price' : 0,
            'cost_price' : 0,
            'sold_count' : 0,
            'unit_count' : 1,
            'stock' : 0,
            'popoverVisible' : false,
            'sku' : sets[sets.length-1][m].sku,
            'height' : sets[sets.length-1][m].height
          };
          for(var p = 0 ; p < this.formData.sku.length ; p ++){
            let skuArray = [];
            sets[sets.length-1][m].sku.map(skuItem =>{
              skuArray.push({
                field_id: skuItem.field_id,
                attr_id: skuItem.attr_id,
              })
            });
            console.log('skuArray');
            console.log(skuArray);
            if(JSON.stringify(this.formData.sku[p].sku).replace(/"/g,'') == JSON.stringify(skuArray).replace(/"/g,'')){
              row = {
                'key':'p'+p,
                'id' : this.formData.sku[p].id,
                'code' : this.formData.sku[p].code,
                'price' : this.formData.sku[p].price,
                'pin_price' :this.formData.sku[p].pin_price,
                'cost_price' : this.formData.sku[p].cost_price,
                'sold_count' : this.formData.sku[p].sold_count,
                'unit_count' : this.formData.sku[p].unit_count,
                'stock' : this.formData.sku[p].stock,
                'popoverVisible' : false,
                'sku' : sets[sets.length-1][m].sku,
                'height' : sets[sets.length-1][m].height
              };
              break ;
            }
          }
          skulist.push(row);
        }
        console.log('skulist')
        console.log(skulist)
        self.skuTable = {
          sku_fields_sets:sets,
          sku_list:skulist,
        }
      },
      //批量设置价格
      setAllPrice(){
        let that = this;
        that.skuTable.sku_list.map(item =>{
          item.pin_price = that.setAll.setAllPriceValue;
        });
        that.setAll.setAllPriceValue = '';
      },




      handleUserManage(record) {
        let self = this
        self.userQuery.tuan_id = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.fetchUserList();
        this.userVisible = true
      },

      fetchUserList(){
        let self = this
        getTuanUserList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.tuanUserList = res.data.list
         
          const pagination = { ...this.userPagination }
        pagination.total = res.data.total
        self.userPagination = pagination
        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.status){
          that.userQuery.status = filters.status[0];
        }else{
          that.userQuery.status = 0;
        }
        const pager = { ...this.pagination }
      pager.current = pagination.current
      that.pagination = pager
      that.userQuery.page = pagination.current
      pager.page = pagination.current
      that.userPagination = pager
      that.fetchUserList()
      },
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>